import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=f3e4ef3e&scoped=true&"
import script from "./phone.vue?vue&type=script&lang=js&"
export * from "./phone.vue?vue&type=script&lang=js&"
import style0 from "./phone.vue?vue&type=style&index=0&id=f3e4ef3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e4ef3e",
  null
  
)

export default component.exports